import { render, staticRenderFns } from "./IcraproHomeView.vue?vue&type=template&id=71ad3424&scoped=true"
import script from "./IcraproHomeView.vue?vue&type=script&lang=ts"
export * from "./IcraproHomeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad3424",
  null
  
)

export default component.exports